import { BookInteractTypes } from "./BookList.utils";

export const mapBtnInteractTypeToFormat = {
  [BookInteractTypes.listen]: "mp3",
  [BookInteractTypes.epub]: "epub",
  [BookInteractTypes.mobi]: "mobi",
  [BookInteractTypes.pdf]: "pdf",
};
